import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, ShieldAlert } from "lucide-react";
import { API } from "@/App";

// Panel admin > Vanta AI > Modération : les demandes refusées (filtre du site puis
// Llama Guard), les plus récentes d'abord.

export default function VantaAIModeration({ hdr }) {
  const [flags, setFlags] = useState(null);
  useEffect(() => {
    axios.get(`${API}/admin/vai/flags`, { headers: hdr() }).then((r) => setFlags(r.data.flags))
      .catch((err) => toast.error(err?.response?.data?.detail || "Chargement impossible"));
  }, [hdr]);

  return (
    <div className="space-y-4" data-testid="vai-admin-moderation">
      <div>
        <h2 className="text-xl font-semibold flex items-center gap-2"><ShieldAlert className="w-5 h-5 text-amber-300" />Modération</h2>
        <p className="text-sm text-white/50 mt-1">Les demandes que Vanta AI a refusées (armes, drogues, piratage, fraude…). La personne a reçu un refus poli.</p>
      </div>
      {flags === null ? <p className="text-sm text-white/40 flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" />Chargement…</p>
        : flags.length === 0 ? <p className="text-sm text-white/40">Aucune demande refusée pour l'instant.</p> : (
          <div className="divide-y divide-white/5 border border-white/10 rounded-xl">
            {flags.map((f) => (
              <div key={f.id} className="px-4 py-3 text-xs">
                <div className="flex flex-wrap gap-x-3 text-white/45"><span>{new Date(f.at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })}</span><span className="text-amber-200">{f.category}</span><span>{f.email}</span><span>{f.where}</span></div>
                <p className="text-white/75 mt-1 break-words">{f.text}</p>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}
